import React, { forwardRef } from 'react'
import CheckComp from '../components/Check'
import TitleComp from '../components/Title'
// import ErrorTip from '../components/errorTip'
import BasicSettings from '../components/BasicSettings'
// 参数Controller, control, register
const Render = function ({
  // watch,
  register,
  // getValues,
  // control,
  // Controller,
  // errors,
  // ...otherProps
}) {
  // console.log(otherProps, control, errors)
  return (
    <BasicSettings register={register}>
      <TitleComp title="校验">
        <CheckComp
          register={register}
          registerName="required"
          // defaultValue={getValues('required')}
          label="必填"
        />
      </TitleComp>
    </BasicSettings>
  )
}

export default forwardRef(Render)
